import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import ClassNames from 'embla-carousel-class-names';
import { addPrevNextBtnsClickHandlers } from './embla-carousel-nav';
import { setupTweenOpacity } from './embla-tween-opacity';
import { addThumbBtnsClickHandlers , addToggleThumbBtnsActive } from './embla-thumbs-nav';
import { isSet } from "../helpers/isset";


function initEmblaCarousels(){
    const homepageSliderNode = document.querySelector('.header--home--js .embla');

    if(isSet(homepageSliderNode)){
        const homepageSliderOpts = {loop: true};
        const homepageSliderViewportNode = homepageSliderNode.querySelector('.embla__viewport');
        const prevBtn = homepageSliderNode.querySelector('.embla__button--prev');
        const nextBtn = homepageSliderNode.querySelector('.embla__button--next');
        
        const homepageSliderEmblaApi = EmblaCarousel(homepageSliderViewportNode, homepageSliderOpts, [
            ClassNames(),
            Autoplay({ delay: 8000 })
        ]);
        
        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            homepageSliderEmblaApi,
            prevBtn,
            nextBtn
        );
    
        homepageSliderEmblaApi.on('destroy', removePrevNextBtnsClickHandlers);
    }
    
    
    const latestNewsSliderNode = document.querySelector('.section--latest-news--js .embla');
    
    if(isSet(latestNewsSliderNode)){
        const latestNewsSliderOpts = {dragFree: true};
        const latestNewsSliderViewportNode = latestNewsSliderNode.querySelector('.embla__viewport');
        EmblaCarousel(latestNewsSliderViewportNode, latestNewsSliderOpts, [ClassNames()]);
    }



    const subTypeSliderNodes = document.querySelectorAll('.sub-types--js .embla');
    subTypeSliderNodes.forEach(function (subTypeSliderElm) {
        const subTypeSliderOpts = {dragFree: true};
        const subTypeSliderViewportNode = subTypeSliderElm.querySelector('.embla__viewport');

        const prevBtn = subTypeSliderElm.querySelector('.embla__button--prev');
        const nextBtn = subTypeSliderElm.querySelector('.embla__button--next');
        
        const subTypeSliderEmblaApi = EmblaCarousel(subTypeSliderViewportNode, subTypeSliderOpts, [ClassNames()]);

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            subTypeSliderEmblaApi,
            prevBtn,
            nextBtn
        );

        subTypeSliderEmblaApi.on('destroy', removePrevNextBtnsClickHandlers);
    });
    
    
    const stockCardSliderNodes = document.querySelectorAll('.card--stock--js .embla');
    const stockCardSliderOpts = {loop: true};
    
    stockCardSliderNodes.forEach(function (stockCardSliderElm) {
        const stockCardSliderViewportElm = stockCardSliderElm.querySelector('.embla__viewport');
    
        const prevBtn = stockCardSliderElm.querySelector('.embla__button--prev');
        const nextBtn = stockCardSliderElm.querySelector('.embla__button--next');
    
        const stockCardSliderEmblaApi = EmblaCarousel(stockCardSliderViewportElm, stockCardSliderOpts);
    
        const removeTweenOpacity = setupTweenOpacity(stockCardSliderEmblaApi);
    
        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            stockCardSliderEmblaApi,
            prevBtn,
            nextBtn
        );
    
        stockCardSliderEmblaApi
            .on('destroy', removeTweenOpacity)
            .on('destroy', removePrevNextBtnsClickHandlers);
    });


    const productGalleryNode = document.querySelector('.product-gallery--js .embla__viewport');
    if(isSet(productGalleryNode)){
        const productGalleryOpts = {loop: true}
        const productGalleryThumbsOpts = { containScroll: 'keepSnaps', dragFree: true }
        const productGalleryThumbsNode = document.querySelector('.embla-thumbs__viewport');

        const emblaApiMain = EmblaCarousel(
            productGalleryNode, 
            productGalleryOpts
        );

        const emblaApiThumb = EmblaCarousel(
            productGalleryThumbsNode, 
            productGalleryThumbsOpts
        );
    
        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
            emblaApiMain,
            emblaApiThumb
        );
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
            emblaApiMain,
            emblaApiThumb
        );

        const prevBtn = productGalleryNode.querySelector('.embla__button--prev');
        const nextBtn = productGalleryNode.querySelector('.embla__button--next');

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApiMain,
            prevBtn,
            nextBtn
        );
    
        emblaApiMain
            .on('destroy', removeThumbBtnsClickHandlers)
            .on('destroy', removeToggleThumbBtnsActive)
            .on('destroy', removePrevNextBtnsClickHandlers)
    
        emblaApiThumb
            .on('destroy', removeThumbBtnsClickHandlers)
            .on('destroy', removeToggleThumbBtnsActive)
    }
}

exports.initEmblaCarousels = initEmblaCarousels;